// SkipLink (Sprint 8 — accesibilidad AAA).
//
// Aparece cuando el usuario tabula desde el inicio del documento.
// Salta al contenido principal (id="main-content") para usuarios
// de teclado / lectores de pantalla que no quieren pasar por toda
// la navegación.

import type { ReactNode } from 'react';

interface SkipLinkProps {
  targetId?: string;
  children?: ReactNode;
}

export function SkipLink({
  targetId = 'main-content',
  children = 'Saltar al contenido principal',
}: SkipLinkProps) {
  return (
    <a
      href={`#${targetId}`}
      className="
        sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50
        focus:rounded-md focus:bg-gold focus:px-4 focus:py-2 focus:text-bg
        focus:shadow-lg
      "
    >
      {children}
    </a>
  );
}
